import React, { createContext, useContext } from 'react';
import { IntlProvider, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { IntlPropType } from './propTypes';

const IntlContext = createContext();

export const TranslationProvider = ({ children }) => {
  const intl = useIntl();
  return (
    <IntlContext.Provider value={{ ...intl }}>{children}</IntlContext.Provider>
  );
};

export const getTranslations = () => {
  const intlCtx = useContext(IntlContext);
  return (id, value) => intlCtx.formatMessage({ id }, value);
};

export const IntlContextProvider = ({ translations, children }) => {
  const { messages, addLocaleData, locale } = translations;

  addLocaleData();

  return (
    <IntlProvider locale={locale} messages={messages}>
      <TranslationProvider>{children}</TranslationProvider>
    </IntlProvider>
  );
};

IntlContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  translations: IntlPropType.isRequired,
};

TranslationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default IntlContext;
